
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Dialog from '@/components/dialog.vue';

import products from './products.vue';
import customPage from './customPage.vue';
import pkRanking from './pkRanking.vue';
import soloPkRanking from './soloPkRanking.vue';

import { imgHost, host } from "@/utils/config";

@Component({
    name: '',
    components: {
        PageFooter,
        'slz-dialog': Dialog,
        products,
        customPage,
        pkRanking,
        soloPkRanking
    }
})
export default class HomePagePlacement extends Vue {

    @Prop({
        default: false
    }) visible!: any;
    @Prop({
        default: {}
    }) selectedData!: any;

    private imgUrl = imgHost;
    private type = 1;
    private show = false;

    @Watch('visible')
    private visibleChange(val){
        this.show = val;
    }

    @Watch('selectedData')
    private selectedDataChange(val){
        this.type = this.selectedData.type || 1;
    }

    private mounted() {
        this.getData();
    }

    private getData() {

    }

    private handleSureSelect(){
        let ref: any = this.$refs[['','products','','','customPage', 'soloPkRanking', 'pkRanking'][this.type]];
        let data = ref.returnchoosemsg();
        if (this.type === 1 && data.ProductName){
            this.$emit('change', {
                LinkResourceId: data.Id,
                LinkInfoJson: data.ProductName,
                LinkResourceType: this.type
            })
        }else if (this.type === 4 && data.PageName){
            this.$emit('change', {
                LinkResourceId: data.Id,
                LinkInfoJson: data.PageName,
                LinkResourceType: this.type
            })
        }else if (this.type === 5 && data.Name){
            this.$emit('change', {
                LinkResourceId: data.Id,
                LinkInfoJson: data.Name,
                LinkResourceType: this.type
            })
        }else if (this.type === 6 && data.Name){
            this.$emit('change', {
                LinkResourceId: data.Id,
                LinkInfoJson: data.Name,
                LinkResourceType: this.type
            })
        }else{
            this.$emit('change', false)
        }
    }

}
